import { createVNode, render, type Component } from "vue";

/**
 * Render a Vue icon component to a raw SVG string suitable for imperative DOM
 * insertion. Scoped `.stroke` / `.fill` classes are replaced with
 * `stroke="currentColor"` / `fill="currentColor"` so the SVG inherits the
 * parent element's text color instead of relying on the icon's scoped CSS.
 */
export function iconToSvgString(component: Component): string {
  const el = document.createElement("div");
  render(createVNode(component), el);
  el.querySelectorAll(".stroke").forEach((path) => {
    path.classList.remove("stroke");
    path.setAttribute("stroke", "currentColor");
  });
  el.querySelectorAll(".fill").forEach((path) => {
    path.classList.remove("fill");
    path.setAttribute("fill", "currentColor");
  });
  const html = el.innerHTML;
  render(null, el);
  return html;
}
